import EventEmitter from "../../../node_modules/eventemitter3/index";
import { PlantillaCorreo, RespuestaPredeterminada, RespuestasPredeterminadasClient, Transition, TransitionsClient } from "../client/Client";
import events from "../Events/EventList";
import EventList from "../Events/EventList";
import { TableFactory, TableInterface } from "../Utilities/Table";

const formRespuestaId = "respuesta-form"
const formRespuestaSelector = "#"+formRespuestaId
const $transitionList = <HTMLSelectElement> document.getElementById("transition-type");
const $from = <HTMLSelectElement>document.getElementById("from");
const $to = <HTMLSelectElement>document.getElementById("to");
let $plantillaFormularId = <HTMLSelectElement>document.querySelector("#plantillaId");

const respuestaIdSelector = "#id";
const respuestaTransitionIdSelector = "#transitionId";
const respuestaUsuarioPuedeEditarSelector = "#usuarioPuedeEditar";
const respuestaTituloSelector = "#titulo"
const respuestaContenidoIdSelector = "#contenido";
let transitionId: number = 0 ;

export default class TransitionsTableComponent{


    dtRespuestasConfiguration = [
        {
            targets: 0,
            data: "id"
        },
        {
            targets: 1,
            data: "titulo"
        },
        {
            targets: 2,
            data: "contenido",
        },
        {
            targets: 3,
            data: "usuarioPuedeEditar",
            render: (puedeEditar:boolean) => puedeEditar? "Si": "No"
        },
        {
            targets: 4,
            data: "id",
            render: (id: number, data: RespuestaPredeterminada ) => `
                <button class='btn btn-primary transition-respuesta-edit' data-transition-id="${data.transitionId}" data-transition-respuesta-id="${id}"><i class='fas fa-edit'></i></button>
                <button class='btn btn-primary transition-respuesta-delete ml-1' data-transition-id="${data.transitionId}" data-transition-respuesta-id="${id}"><i class='fas fa-trash'></i></button>
                ` 
        }

    ]
    /**
     *
     */

    dtConfiguration = [
        {
            targets: 0,
            data: "id"
        },
        {
            targets: 1,
            data: "description"
        },
        {
            targets: 2,
            data: "from.name",
        },
        {
            targets: 3,
            data: "to.name",
        },
        {
            targets: 4,
            data: "plantillaCorreo",
            render: (plantillaCorre: PlantillaCorreo)=>{
                return  plantillaCorre?.nombre ?? "Sin plantilla";
            }
        },
        {
            targets: 5,
            data: "tipoTransicion",
            render : (transitionType: number)=>{
                return Array.from($transitionList.options).find(e=>e.value == transitionType.toString())?.textContent??"Cerrada";
            }
        },
        {
            targets: 6,
            data: "id",
            render: (id: number) => `
                <button class='btn btn-primary transition-edit' data-transition-id="${id}"><i class='fas fa-edit'></i></button>
                <button class='btn btn-primary transition-delete ml-1'><i class='fas fa-trash'></i></button>
                <button class='btn btn-primary transition-respuestas ml-1' data-transition-id="${id}"><i class='fas fa-list'></i></button>
                ` 
        }
    ]

    selectedTransition:Transition=null;
    selectedRow: HTMLTableRowElement= null;

    table: TableInterface<Transition>
    tableRespuestas: TableInterface<RespuestaPredeterminada>
    constructor(private eventEmitter: EventEmitter, 
        private tableFactory: TableFactory<Transition>, 
        private tableRespuestaFactory: TableFactory<RespuestaPredeterminada>, 
        private transitionClient: TransitionsClient,
        private respuestasPredeterminadasClient: RespuestasPredeterminadasClient) {
        this.fetchTransitions();
        this.eventEmitter.on(EventList.PLANTILLA_ID_CHANGED,this.fetchTransitions)
        this.eventEmitter.on(EventList.TRANSITIONS_FETCHED, this.init)
        this.eventEmitter.on(EventList.TRANSITION_UPDATED,this.updateTransitionHandler)
        this.eventEmitter.on(EventList.TRANSITION_CREATED,this.addTransition)
        this.eventEmitter.on(EventList.RESPUESTAS_FETCHED, this.respuestasFetchedHandler)
        this.eventEmitter.on(EventList.RESPUESTA_UPDATED, this.RespuestaChangeHandler);
        this.eventEmitter.on(EventList.RESPUESTA_CREATED, this.RespuestaChangeHandler);
        this.eventEmitter.on(EventList.RESPUESTA_DELETED, this.RespuestaChangeHandler);
        $(document).on("click",".transition-respuesta-edit",this.selectTransitionResponseHandler)
        $(document).on("click",".transition-respuesta-delete",this.deleteTransitionResponseHandler)      
        $(document).on("click",".transition-delete",this.deleteTransitionHandler)
        $(document).on("click",".transition-respuestas",this.respuestasHandler)
        $(document).on("click",".transition-edit",this.editHandler)
        $(document).on("submit",formRespuestaSelector, this.respuestaSubmitHandler);
                
    }
    deleteTransitionResponseHandler = (evt: Event)=> {
        let row = (<HTMLElement> evt.target).closest("tr");
        let data = this.tableRespuestas.GetData(row);
        Alerta.SwalConfirm("¿Desea eliminar esta respuesta?",
        ()=> this.deleteTransitionRespuesta(data),()=>{},2);
    }
    deleteTransitionRespuesta = (data: RespuestaPredeterminada) => {
        this.respuestasPredeterminadasClient.delete(data.id, data.transitionId?.toString())
        .then(()=>this.eventEmitter.emit(EventList.RESPUESTA_DELETED, data));
        
    }
    selectTransitionResponseHandler = (evt: Event)=> {
        let row = (<HTMLElement> evt.target).closest("tr");
        let data = this.tableRespuestas.GetData(row);

        (<HTMLInputElement> document.querySelector(`${formRespuestaSelector} ${respuestaIdSelector}`)).value = data.id.toString();
        (<HTMLInputElement> document.querySelector(`${formRespuestaSelector} ${respuestaTransitionIdSelector}`)).value = data.transitionId.toString();
        (<HTMLInputElement> document.querySelector(`${formRespuestaSelector} ${respuestaUsuarioPuedeEditarSelector}`)).checked = data.usuarioPuedeEditar;
        (<HTMLInputElement> document.querySelector(`${formRespuestaSelector} ${respuestaTituloSelector}`)).value = data.titulo;
        (<HTMLInputElement> document.querySelector(`${formRespuestaSelector} ${respuestaContenidoIdSelector}`)).value = data.contenido;
    }

    respuestaSubmitHandler = (evt: Event)=>{
        evt.preventDefault();
        let form = <HTMLFormElement> evt.target;
        let respuesta: RespuestaPredeterminada = new RespuestaPredeterminada();
        respuesta.id = parseInt((<HTMLInputElement> document.querySelector(`${formRespuestaSelector} ${respuestaIdSelector}`)).value);
        respuesta.transitionId = transitionId;
        respuesta.usuarioPuedeEditar = (<HTMLInputElement> document.querySelector(`${formRespuestaSelector} ${respuestaUsuarioPuedeEditarSelector}`)).checked
        respuesta.titulo = (<HTMLInputElement> document.querySelector(`${formRespuestaSelector} ${respuestaTituloSelector}`)).value
        respuesta.contenido = (<HTMLInputElement> document.querySelector(`${formRespuestaSelector} ${respuestaContenidoIdSelector}`)).value

        if(!respuesta.id){
            respuesta.id = 0;
            this.respuestasPredeterminadasClient.post(transitionId,respuesta)
            .then(e=>this.eventEmitter.emit(EventList.RESPUESTA_CREATED, e));
        }
        else{
            this.respuestasPredeterminadasClient
            .put(transitionId, respuesta.id, respuesta)
            .then(e=>this.eventEmitter.emit(EventList.RESPUESTA_UPDATED,e));
        }
    }

    RespuestaChangeHandler = (respuestaPredeterminada: RespuestaPredeterminada)=>{
        this.fetchRespuestasPredeterminadas(respuestaPredeterminada.transitionId);
    }

    fetchRespuestasPredeterminadas = (id: number)=>{
        return this.respuestasPredeterminadasClient.getAll(id)
        .then(response=>{
            this.eventEmitter.emit(EventList.RESPUESTAS_FETCHED, response)
        });
    }

    respuestasFetchedHandler = (respuestas: RespuestaPredeterminada[])=>{
        this.initRespuestas(respuestas);
        (<HTMLFormElement>document.querySelector(formRespuestaSelector)).reset()
    }

    fetchTransitions = ()=>{
        this.transitionClient.getParaPlantilla(parseInt($plantillaFormularId.value))
        .then(transitions=> this.eventEmitter.emit(EventList.TRANSITIONS_FETCHED, transitions));
    }

    updateTransitionHandler = (transition: Transition)=>{
        let target = <HTMLButtonElement>document.querySelector(`button[data-transition-id='${transition.id}']`)
        this.fetchTransitions();
        //this.selectedRow = target.closest("tr");
        //this.table.UpdateRow(this.selectedRow,transition);
        //this.table.Draw();
    }

    private _respuestasHandler = (evt: Event) => {
        let target = <HTMLElement>evt.target;
        let button = target.closest("button");
        let _transitionId = button.dataset.transitionId;
        let modal:any = $("#app-modal-transition-respuestas").appendTo("body");
        modal.modal("show");
        transitionId = parseInt(_transitionId)
        this.fetchRespuestasPredeterminadas(transitionId);
    };
    public get respuestasHandler() {
        return this._respuestasHandler;
    }
    public set respuestasHandler(value) {
        this._respuestasHandler = value;
    }

    deleteTransitionHandler = (evt: Event)=>{
        let target = <HTMLElement>evt.target;
        this.selectedRow = target.closest("tr");

        this.selectedTransition = this.table.GetData(this.selectedRow);
        Alerta.SwalConfirm("Deseas eliminar esta transición?",this.deleteTransition,()=>{},2)
    }

    editHandler = async (evt: Event)=>{
        let target = <HTMLElement>evt.target;
        this.selectedRow = target.closest("tr");
        this.selectedTransition = this.table.GetData(this.selectedRow);

        this.eventEmitter.emit(EventList.TRANSITION_SELECTED,this.selectedTransition);         

        //TODO
    }

    deleteTransition= async() =>{
        try{

            await this.transitionClient.delete(this.selectedTransition.id);
            this.eventEmitter.emit(EventList.TRANSITION_DELETED, this.selectedTransition.id);
            this.table.DeleteRow(this.selectedRow);
            this.table.Draw();
            this.selectedTransition = null;

        }
        catch(ex){
            Notify.error("Error al Eliminar transición");
        }
    }

    init = (transitions: Transition[])=>{
        if(!this.table){
            this.table = this.tableFactory.Init(transitions,"#transitions-table",this.dtConfiguration); 
        }else{
            this.table.Reset(transitions);
            this.table.Draw();
        }
        
    }

    initRespuestas = (respuestas: RespuestaPredeterminada[])=>{
        if(!this.tableRespuestas){
            this.tableRespuestas  = this.tableRespuestaFactory.Init(respuestas, "#respuestas-table", this.dtRespuestasConfiguration)
        }
        else{
            this.tableRespuestas.Reset(respuestas);
            this.tableRespuestas.Draw();
        }
    }

    addTransition = (transition: Transition)=>{
        this.fetchTransitions();
        //this.table.AddRow(transition);
        //this.table.Draw();
    }
}